import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { portalApi, formatPortalError } from "@/lib/portalApi";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
    const [client, setClient] = useState(null);
    const [status, setStatus] = useState("checking");

    const refresh = useCallback(async () => {
        try {
            const { data } = await portalApi.get("/portal/me");
            setClient(data);
            setStatus("authed");
        } catch {
            setClient(null);
            setStatus("guest");
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        try {
            const { data } = await portalApi.post("/portal/login", { email, password });
            setClient(data.client);
            setStatus("authed");
            return { ok: true };
        } catch (err) {
            return { ok: false, error: formatPortalError(err, "Login failed.") };
        }
    };

    const logout = async () => {
        try {
            await portalApi.post("/portal/logout");
        } catch {
            /* ignore */
        }
        setClient(null);
        setStatus("guest");
    };

    return (
        <ClientAuthContext.Provider value={{ client, status, login, logout, refresh }}>
            {children}
        </ClientAuthContext.Provider>
    );
}

export const useClientAuth = () => {
    const ctx = useContext(ClientAuthContext);
    if (!ctx) throw new Error("useClientAuth must be used inside ClientAuthProvider");
    return ctx;
};
